import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbars } from 'settle-ui/hooks/useSnackbars/useSnackbars'

export const useWelcomeVerifiedUser = () => {
  const router = useRouter()
  const { showAlert } = useSnackbars()
  const { t } = useTranslation()

  useEffect(() => {
    if (router.query.welcome) {
      const noName = router.query.welcome === 'true'
      const message = noName ? t('welcome') : t('welcomeUser', { firstName: router.query.welcome })

      showAlert(message)

      delete router.query.welcome
      router.push({ query: router.query })
    }
  }, [router, t, showAlert])
}
